<div [ngClass]="{'data-loading': calculatorService.dataLoading}" class="container-fluid">
  <!--#region entête avec les boutons"-->
  <div class="row p-1 align-items-center">
    <ng-container *ngIf="calculatorService.LinkedMissions.length > 0">

      <button *ngIf="displayMode !== 'CONFIG'"
              class="q-btn q-secondary"
              [title]="displayMode === 'CALCULATE' ? 'Quitter le calcul' : 'Afficher le calcul - Indisponible si projet/mission non créé'"
              (click)="SwitchDisplayMode()"
              [disabled]="DisableCalculate()">
        <i [ngClass]="[displayMode === 'CALCULATE' ? 'fas fa-eye' : 'fas fa-calculator']"></i>
      </button>

      <button *ngIf="displayMode === 'VIEW' || (displayMode === 'CALCULATE' && calculatorService?.Mission?.BoName !== 'BO_MCAC')"
              class="q-btn q-main"
              title="Enregistrer la liste des travaux"
              (click)="OpenModaleSaveMission()"
              [disabled]="calculatorService.savingMission">
        <i [ngClass]="[calculatorService.savingMission ? 'fas fa-pulse fa-spinner fa-spin' : 'fas fa-save']"></i>
        <span class="ml-1">Enregistrer</span>
      </button>

      <button *ngIf="displayMode === 'CALCULATE' && calculatorService?.Mission?.BoName !== 'BO_MCAC'"
              class="q-btn q-danger"
              title="Réinitialisation: supprimer toutes les lignes de devis et regénérer le plan de charge et les lignes de devis"
              (click)="OpenModalReinitialisation()"
              [disabled]="deleteMission">
        <i [ngClass]="[deleteMission ? 'fas fa-pulse fa-spinner fa-spin' : 'fab fa-rev']"></i>
        <span class="ml-1">Réinitialiser</span>
      </button>

      <button *ngIf="displayMode !== 'CALCULATE'" title="{{displayMode === 'CONFIG' ? 'Quitter la configuration' : 'configurer'}}"
              (click)="OnClickConfig()"
              class="q-btn"
              [ngClass]="[displayMode === 'CONFIG' ? 'q-secondary' : 'q-c-main']">
        <i [ngClass]="[displayMode === 'CONFIG' ? 'fas fa-eye ' : 'fas fa-cog']"></i>
      </button>

      <button *ngIf="displayMode === 'CALCULATE'" title="Éditer les obligations"
              (click)="ToogleConfigObligations()"
              class="q-btn q-c-main">
        <i class="fas fa-cog"></i>
      </button>

      <select class="q-main-select" *ngIf="displayMode === 'VIEW' && !isActionCo && calculatorService.Mission?.BoModels?.length > 0" (change)="LoadModel($event.target.value)">
        <option value="">Sélectionner un modèle</option>
        <option *ngFor="let model of calculatorService.Mission.BoModels" value="{{model.value}}">{{model.key}}</option>
      </select>

      <button *ngIf="displayMode === 'VIEW'" class="q-btn q-secondary ml-2"
              [ngbPopover]="popoverSaveModel"
              [placement]="['bottom', 'top']"
              autoClose="outside"
              container="body"
              #p1="ngbPopover"
              title="sauvegarder en tant que nouveau modèle">
        <i class="fas fa-window-restore"></i>
      </button>

      <ng-template #popoverSaveModel>
        <div class="w-100">
          <form #form>
            <div class="container-fluid">
              <div class="row">
                <input name="input" type="text" class="q-input-border mb-0 mr-2"
                       [ngClass]="{'q-c-danger': emptyModelName}"
                       [(ngModel)]="newModelName"
                       placeholder="nouveau modèle"
                       (focus)="emptyModelName = false;" />
                <button class="col-auto q-btn q-main" (click)="SaveBoModel()">
                  <i class="fas fa-save"></i>
                </button>
              </div>
            </div>
          </form>
        </div>
      </ng-template>



      <button *ngIf="displayMode === 'CONFIG'"
              title="Exporter la configuration"
              (click)="ExportConfig()"
              class="q-btn q-white">
        <i class="fas fa-file-export m-0"></i>
      </button>

      <input *ngIf="displayMode === 'CONFIG'" type="file" id="filemanuel" class="d-none" (change)="OpenModalImport($event)" accept=".xml" />
      <label *ngIf="displayMode === 'CONFIG'"
             for="filemanuel"
             title="Importer la configuration"
             class="q-btn q-white mb-0">
        <i class="fas fa-file-import m-0"></i>
      </label>

      <button *ngIf="calculatorService?.Mission?.BoName !== 'BO_MCAC' && calculatorService.LinkedMissions.length > 1"
              title="Montant total des missions {{calculatorService?.Amount | money}} HT, Remise totale des missions {{calculatorService?.Discount | money}} HT"
              class="rounded-button q-dark-secondary py-1 px-2 ml-1"
              style="display: unset;">
        <span class="q-bold mr-2"> Montant total :</span>
        <span>{{(calculatorService?.Amount ? calculatorService.Amount : '0') | money}}</span>
      </button>

    </ng-container>

  </div>
  <!--#endregion-->
  <!--#region entête avec les différents onglets de missions-->
  <div class="row align-items-center">

    <ng-container *ngFor="let mission of calculatorService.LinkedMissions; let index = index">
      <button class="p-1 col-auto q-btn" (click)="OnChangeMission(mission, mission.loadingDatas)"
              [ngClass]="{'q-main': mission.CodeBo === calculatorService?.Mission?.CodeBo && mission.Ident === calculatorService?.Mission?.Ident && mission.IdRelation === calculatorService?.Mission?.IdRelation }"
              [title]="mission.Info">
        <span>{{mission.TabLabel}}</span>
        <i *ngIf="mission.loadingDatas" class="ml-2 fas fa-pulse fa-spinner fa-spin"></i>
        <i *ngIf="isActionCo && mission && !mission.loadingDatas && (!mission.Ident || mission?.Ident == '0' || mission?.IsProjet)"
           (click)="OpenModalDeleteMission(mission, index)" class="ml-2 fas fa-trash q-c-danger"></i>
      </button>
    </ng-container>

    <ng-container *ngIf="calculatorService?.UnlinkedMissions.length > 0">
      <button *ngIf="isActionCo && (status.toUpperCase() != 'GAGNE' && status.toUpperCase() != 'PERDU')"
              class="p-1 col-auto q-btn q-main"
              placement="right"
              autoClose="outside"
              [ngbPopover]="templatePopoverPlusButton"
              #popoverPlusButton="ngbPopover"
              [disabled]="calculatorService.lockTabs"
              container="body">
        <i class="fas fa-plus-circle"></i>
      </button>
      <ng-template #templatePopoverPlusButton>
        <ng-container *ngFor="let mission of calculatorService?.UnlinkedMissions; let i = index">
          <div class="select-type q-pointer px-2"
               (click)="OnAddingTab(mission, '', i)"
               [placement]="['right-top', 'left-top']"
               triggers="manual"
               autoClose="outside"
               [ngbPopover]="templatePopoverModels"
               popoverClass="modelsPopovers"
               #popoverModels="ngbPopover"
               [disablePopover]="!mission.BoModels || mission.BoModels.length < 1"
               container="body"
               (mouseenter)="OnMouseEnterOnUnlinkedTab(popoverModels, mission, i);"
               (mouseleave)="lastPopoverModelTab = popoverModels;"
               [ngClass]="{'model-caret': mission.BoModels && mission.BoModels.length > 0}">
            {{mission.TabLabel}}
          </div>
        </ng-container>
      </ng-template>
      <ng-template #templatePopoverModels>
        <div class="w-100 px-2 q-bold">Modèles</div>
        <ng-container *ngFor="let boModel of focusedTab.BoModels; let j = index">
          <div class="select-type q-pointer px-2"
               (click)="OnAddingTab(focusedTab, boModel.value, focusedTabIndex)">{{boModel.key}}</div>
        </ng-container>
      </ng-template>
    </ng-container>

  </div>
  <!--#endregion-->

  <div *ngIf="calculatorService.Mission && calculatorService.LinkedMissions.length > 0" class="row align-items-center">
    <span class="p-1 col-auto q-bold">{{calculatorService.Mission.Label}}</span>
    <button title="Tarif indicatif total de la mission {{calculatorService.Mission.Amount | money}} HT, Remise sur LDM {{calculatorService.Mission.Discount | money}} HT" class="p-1 col-auto rounded-button q-dark-secondary py-1 px-2 ml-1 my-1">{{calculatorService.Mission.Amount | money}}</button>
  </div>
  <ng-container *ngIf="calculatorService.LinkedMissions.length == 0">
    <div class="container-fluid">
      <div class="row w-100 justify-content-center q-nodata q-c-main ">
        <h3>
          <i class="fas fa-calculator mr-1"></i>
          <label class="big-title">Calculateur</label>
        </h3>
      </div>
      <div class="row w-100 justify-content-center q-nodata q-c-main"><i class="fas fa-exclamation-circle"></i></div>
      <ng-container *ngIf="isActionCo && (status.toUpperCase() == 'GAGNE' || status.toUpperCase() == 'PERDU' || isCloture) else NoMission">
        <div class="row w-100 justify-content-center q-nodata q-c-main">Les projets de missions liés à cette action ont été transformés et clôturés.</div>
      </ng-container>
      <ng-template #NoMission>
        <div class="row w-100 justify-content-center q-nodata q-c-main">Aucun projet de mission :</div>
        <div class="row w-100 justify-content-center q-nodata q-c-main">Cliquez sur le + pour créer un projet de mission.</div>
      </ng-template>
    </div>
  </ng-container>

  <q-calculateur-view *ngIf="displayMode === 'VIEW'"></q-calculateur-view>
  <q-calculateur-config *ngIf="displayMode === 'CONFIG'" (openModalCondition)="OpenModalCondition($event.Event, $event.Pdc)"></q-calculateur-config>
  <q-calculateur-calcul *ngIf="displayMode === 'CALCULATE'" (openModalCondition)="OpenModalCondition($event.Event, $event.Pdc)" (mission)="emitMission($event)"></q-calculateur-calcul>
</div>
<ng-template #ModalImport let-modal>
  <div class="modal-body">
    <button type="button" class="close" aria-label="Close" (click)="modalImport.close();">
      <span aria-hidden="true">&times;</span>
    </button>
    <div class=" row">
      <h3 class="col-12 q-c-main q-bold" style="text-align: center;">Importer le fichier ?</h3>
      <h5 class="col-12 q-c-main q-bold" style="text-align: center;">(Attention votre configuration actuelle sera supprimée)</h5>
      <h6 class="col-12 q-c-secondary q-bold" style="text-align: center;">nous vous conseillons d'exporter votre configuration actuelle avant tout import.</h6>
      <button class="q-btn q-danger col-auto ml-auto mt-4" aria-label="Close" (click)="modalImport.close();">Annuler</button>
      <button *ngIf="!importingConfig" class="q-btn q-main col-auto mt-4" (click)="ImportConfig()">
        <i class="fas fa-save mr-2"></i>Valider l'import
      </button>
      <button *ngIf="importingConfig" class="q-btn q-main col-auto mt-4">
        <i class="fas fa-pulse fa-spin fa-spinner mr-2" disabled></i>Valider l'import
      </button>
    </div>
  </div>
</ng-template>

<ng-template #ModalConfirmReinitialisation let-modal>
  <div class="modal-body">
    <button type="button" class="close" aria-label="Close" (click)="modal.dismiss();">
      <span aria-hidden="true">&times;</span>
    </button>
    <div class=" row">
      <h3 class="col-12 q-c-main q-bold" style="text-align: center;">Confirmer la réinitialisation du plan de charge</h3>
      <button class="q-btn q-danger col-auto ml-auto mt-4" aria-label="Close" (click)="modal.dismiss();">Annuler</button>
      <button *ngIf="!reinitMission" class="q-btn q-main col-auto mt-4" (click)="ReinitMission()">
        <i class="fas fa-save mr-2"></i>Valider la réinitialisation
      </button>
      <button *ngIf="reinitMission" class="q-btn q-main col-auto mt-4">
        <i class="fas fa-pulse fa-spin fa-spinner mr-2" disabled></i>Valider la réinitialisation
      </button>
    </div>
  </div>
</ng-template>

<ng-template #ModalConfirmDeleteMission let-modal>
  <div class="modal-body">
    <button type="button" class="close" aria-label="Close" (click)="modal.dismiss();">
      <span aria-hidden="true">&times;</span>
    </button>
    <div class=" row">
      <h3 class="col-12 q-c-main q-bold" style="text-align: center;">Confirmer la suppression de la mission</h3>
      <button class="q-btn q-danger col-auto ml-auto mt-4" aria-label="Close" (click)="modal.dismiss();">Annuler</button>
      <button *ngIf="!deleteMission" class="q-btn q-main col-auto mt-4" (click)="DeleteMission()">
        <i class="fas fa-save mr-2"></i>Valider la suppression
      </button>
      <button *ngIf="deleteMission" class="q-btn q-main col-auto mt-4">
        <i class="fas fa-pulse fa-spin fa-spinner mr-2" disabled></i>Valider la suppression
      </button>
    </div>
  </div>
</ng-template>

<ng-template #ModalConfirmUpdateMontantMission let-modal>
  <div class="modal-body">
    <!--<button type="button" class="close" aria-label="Close" (click)="modal.dismiss();">
      <span aria-hidden="true">&times;</span>
    </button>-->
    <div class=" row">
      <h5 class="col-12 q-c-main q-bold" style="text-align: center;">Enregistrement de la liste des travaux</h5>
      <h8 class="col-12 q-c-main q-bold" style="text-align: center;">Souhaitez-vous mettre à jour les montants de la mission?</h8>
    </div>
    <div class="row mt-4">
      <div class="col-6" style="justify-content: flex-end; display: flex;">
        <button class="q-btn q-main" title="Enregistrer la liste des travaux et mettre à jour les montants" (click)="SaveMission(true);">
          <i class="fas fa-save"></i>Oui
        </button>
      </div>
      <div class="col-6" style="justify-content: flex-start; display: flex;">
        <button class="q-btn" title="Enregistrer la liste des travaux sans mettre à jour les montants" (click)="SaveMission(false);">
          <i class="fas fa-save"></i>Non
        </button>
      </div>
    </div>
    </div>
</ng-template>


<ng-template #ModalConfirmUpdateMontantMissionCAC let-modal>
  <div class="modal-body">
    <!--<button type="button" class="close" aria-label="Close" (click)="modal.dismiss();">
      <span aria-hidden="true">&times;</span>
    </button>-->
    <div class=" row">
      <h5 class="col-12 q-c-main q-bold" style="text-align: center;">Enregistrement de la Mission CAC</h5>
      <h8 class="col-12 q-c-main q-bold" style="text-align: center;">Souhaitez-vous enregistrer les modifications effectuées?</h8>
    </div>
    <div class="row mt-4">
      <div class="col-6" style="justify-content: flex-end; display: flex;">
        <button class="q-btn q-main" title="Enregistrer les données de la mission CAC" (click)="SaveMissionCAC(true);">
          <i class="fas fa-save"></i>Oui
        </button>
      </div>
      <div class="col-6" style="justify-content: flex-start; display: flex;">
        <button class="q-btn" title="" (click)="SaveMissionCAC(false);">
          <i class="fas fa-save"></i>Non
        </button>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #ModalConditions let-modal>
  <div class="modal-body">
    <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click'); showCondition = false;">
      <span aria-hidden="true">&times;</span>
    </button>
    <div class=" row container-card p-0">
      <div class="col-lg-3">
        <h3 class="w-100 q-c-main q-bold" style="text-align: center;">Liste des Obligations </h3>
        <div class="row justify-content-center">
          <ng-container *ngFor="let pdc of selectedPdc.Values">
            <div [ngClass]="{'selected-card': codeCondition === pdc.Code}" class="col-md-5 col-lg-12 q-card m-3 q-pointer" style="font-size: 1rem;" (click)="DelayCodeCondition(pdc.Code); codeCondition = pdc.Code;">
              <h6 class="col-12 q-c-main q-bold d-flex align-items-center">
                {{pdc.Info}}
                <i class="fas fa-edit q-c-secondary d-flex ml-auto" (click)="ToogleBoObligation(pdc.Ident)"></i>
              </h6>
              <div class="col-12">
                <span>Code condition: </span>
                <span class="q-bold q-c-main">{{pdc.Code}}</span>
              </div>


              <div class="col-12" *ngIf="pdc.Date">
                <span>Date utilisateur: </span>
                <span class="q-bold q-c-main">{{pdc.Date}}</span>
              </div>
              <div class="col-12" *ngIf="pdc.Days">
                <span>Jour utilisateur: </span>
                <span class="q-bold q-c-main">{{pdc.Days}}</span>
              </div>
              <ng-container *ngIf="codeConditionWithDelay !== pdc.Code && codeCondition !== pdc.Code">
                <div [ngClass]="{'invisible': codeCondition === pdc.Code}" class="col-12" *ngIf="pdc.Duration">
                  <span>Durée fixe OU utilisateur: </span>
                  <span class="q-bold q-c-main">{{pdc.Duration}}</span>
                </div>
                <div [ngClass]="{'invisible': codeCondition === pdc.Code}" class="col-12" *ngIf="pdc.Frequency">
                  <span>Périodicité fixe OU utilisateur: </span>
                  <span class="q-bold q-c-main">{{pdc.Frequency}}</span>
                </div>
                <div [ngClass]="{'invisible': codeCondition === pdc.Code}" class="col-12" *ngIf="pdc.Quantity">
                  <span>Quantité: </span>
                  <span class="q-bold q-c-main">{{pdc.Quantity}}</span>
                </div>
              </ng-container>
              <ng-container *ngIf="codeConditionWithDelay === pdc.Code || codeCondition === pdc.Code">
                <div class="col-12" *ngIf="pdc?.BoProperties?.length > 0">
                <button class="q-btn q-success"
                        (click)="SaveInlinePropertiesDatas(pdc)"
                        [disabled]="isSavingProps">
                  <i [ngClass]="[isSavingProps ? 'fas fa-pulse fa-spinner' : 'fas fa-save']"></i>
                  </button>
                </div>
                <ng-container *ngFor="let prop of pdc.BoProperties">
                  <div class="col-12">
                    <span>{{prop.Label}}: </span>
                    <q-bo-property-inline [property]="prop" mode="INPUT"></q-bo-property-inline>
                  </div>
                </ng-container>
              </ng-container>
            </div>
          </ng-container>
        </div>
      </div>
      <div class="col-lg-9">
        <q-conditions *ngIf="showCondition && (!displayBo && !boDisplayed)" [code]="codeCondition"></q-conditions>

        <ng-container *ngIf="displayBo">
          <div class="w-100 row d-flex">
            <div class="row col-12 mt-0 mb-2">
              <div class="col-auto ml-auto">
                <button (click)="OnCloseBoObligation(null)" title="Annuler l'édition" class="btn-icon">
                  <i Class="fas fa-undo q-c-danger q-pointer"></i>
                </button>
              </div>
            </div>
            <q-bodisplay class="w-100 h-100 mb-5" [item]="boModel" (sendEvent)="OnCloseBoObligation($event)"></q-bodisplay>
          </div>
        </ng-container>
      </div>
    </div>
  </div>
</ng-template>
